import * as React from "react";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { BootstrapModalForm, Input } from "components/bootstrap";
import { InputStaticFieldsStore } from "stores/inputs/InputStaticFieldsStore";
import { KEY_PREFIX } from "hooks/usePaginatedInputs";
const StaticFieldForm = ({ input, setShowModal }) => {
  const [fieldName, setFieldName] = useState("");
  const [fieldValue, setFieldValue] = useState("");
  const queryClient = useQueryClient();
  const addStaticField = () => {
    InputStaticFieldsStore.create(input, fieldName, fieldValue).then(() => {
      setShowModal(false);
      queryClient.invalidateQueries({ queryKey: KEY_PREFIX });
    });
  };
  const handleFieldChange = (name, event) => {
    const { value } = event.target;
    if (name === "name") {
      setFieldName(value);
    }
    if (name === "value") {
      setFieldValue(value);
    }
  };
  return /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: true,
      title: "Add static field",
      submitButtonText: "Add field",
      onCancel: () => {
        setShowModal(false);
      },
      onSubmitForm: addStaticField
    },
    /* @__PURE__ */ React.createElement("p", null, "Define a static field that is added to every message that comes in via this input. The field is not overwritten If the message already has that key. Key must only contain alphanumeric characters or underscores and not be a reserved field."),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "text",
        value: fieldName,
        onChange: (event) => {
          handleFieldChange("name", event);
        },
        id: "field-name",
        label: "Field name",
        required: true,
        pattern: "[A-Za-z0-9_]*",
        title: "Should consist only of alphanumeric characters and underscores."
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        value: fieldValue,
        onChange: (event) => {
          handleFieldChange("value", event);
        },
        type: "text",
        id: "field-value",
        label: "Field value",
        required: true
      }
    )
  );
};
export default StaticFieldForm;
